export const environment = {
  production: false,
  authServiceUrl: 'https://hub-keycloak.demo.irembolabs.com',
  authRealm: 'irembo',
  authClientId: 'officers-portal',
  authSuccessRedirectUrl: 'https://officer-portal.demo.irembolabs.com',
  officerRoles: {
    ROLE_OFFICER_ADMIN: 'Officer Admin',
    ROLE_OFFICER_MANAGER: 'Officer Manager',
    ROLE_OFFICER: 'Officer',
  },
  apiGatewayBaseUrl: 'https://officer-gateway.demo.irembolabs.com',
  allowUploadPreviousFiles: false,
  DEFAULT_LOCALE: 'en-US',
  DEFAULT_LOCALE_NAME: 'English',
  translationSourceUrl: 'https://officer-gateway.demo.irembolabs.com',
  customemailValidationRegex:
    /^[^<>()[\]\\,;:%#^\s"$&!@]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/,
  customphoneValidationRegex: /^07[2-9][0-9]{7}$/,
  AESEncryptionKey: 'encryptionKey',
  isMetabaseDashboardReportsEnabled: false,
  MIXPANEL_TOKEN: '',
  IS_SENDING_ANALYTICS_EVENTS_ACTIVE: false,
  officerFederationEnabled: false,
};
